"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="252752" id="푸터" className="dark bg-background text-foreground relative overflow-hidden pt-20 pb-8">
      
      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
        <div className="grid grid-cols-1 gap-12 lg:gap-8 mb-16 text-center">
          
          <div className="text-center justify-center">
            <div className="space-y-4">
              <div className="space-y-1">
                <p className="text-foreground font-bold leading-tight font-default !text-[25px]">
                  입학하면 졸업까지 책임지는
                </p>
                <p className="text-primary font-bold leading-tight font-default !text-[25px]">
                  건양사이버대학교
                </p>
                <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto font-default pt-2 !text-xl">
                  100% 온라인 4년제 정규 학위
                </p>
              </div>
            </div>
          </div>

        </div>

        <Separator className="bg-border/20 mb-8" />

        <div className="text-center text-sm text-muted-foreground font-default mb-4">
          <p>건양사이버대학교 입학지원센터</p>
        </div>

        <div className="text-center text-sm text-muted-foreground font-default mb-2">
          <p>주소 35365, 대전광역시 서구 관저동로 158 건양사이버대학교</p>
          <p>전화 1899-3330</p>
          <p>팩스 042-722-0069</p>
          <p>개인정보보호책임자 김재형</p>
          <p>등록번호 314-82-15223</p>
        </div>

        <div className="text-center text-sm text-muted-foreground font-default">
          <p>&copy; {currentYear} 건양사이버대학교 입학지원센터. All rights reserved.</p>
        </div>
      </div>
    </section>;
}